import { render, staticRenderFns } from "./bid-purchase-list.html?vue&type=template&id=5b64c7b6&scoped=true&external"
import script from "./bid-purchase-list.js?vue&type=script&lang=js&external"
export * from "./bid-purchase-list.js?vue&type=script&lang=js&external"
import style0 from "./bid-purchase-list.scss?vue&type=style&index=0&id=5b64c7b6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b64c7b6",
  null
  
)

export default component.exports